module.exports = __webpack_public_path__ + "media/images/contact-e82d6920b0fdc18da781ae343081f5de.png";